/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateRegistrationUserDto { 
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    reasonForSignUp?: string;
    companyInfo?: string;
    salutation?: string;
}

